import { ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'pivot-delete-field-renderer',
  templateUrl: './pivot-delete-field.renderer.html',
})
export class PivotDeleteFieldRenderer implements IWizItemRenderer<null, [string, string]> {
  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  owner: null;
  private _data: [string, string];
  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: [string, string]) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get data(): [string, string] {
    return this._data;
  }
}
